import Transformer from './../transformer'

export default class CampTransformer extends Transformer {
  static fetch(camp) {
    return {
      addDate: camp.add_date,
      address: camp.address,
      distanceToExit: camp.distance_to_exit,
      highwayKm: camp.highway_km,
      name: camp.name,
    }
  }
}


// WEBPACK FOOTER //
// ./src/transformers/sinister/camp.js